import {
  AutocompleteInput,
  ReferenceInput,
} from "react-admin";
import MuiDatePickerInput from "../../common/MuiDatePickerInput";

const accountReceivableBadDebtHistoriesFilterList = (permissions) => {
  const defaultFilter = [
    <MuiDatePickerInput
      alwaysOn
      source="start_date"
      variant="outlined"
      label="mine.label.start_date"
      maxDateSource="end_date"
    />,
    <MuiDatePickerInput
      alwaysOn
      source="end_date"
      variant="outlined"
      label="mine.label.end_date"
      minDateSource="start_date"
    />,
    <ReferenceInput
      label="mine.label.customer"
      source="customer_id"
      reference="customers"
      alwaysOn
    >
      <AutocompleteInput optionText="name" variant="outlined" />
    </ReferenceInput>,
  ];
  if (permissions && permissions.update_company) {
    defaultFilter.splice(
      2,
      0,
      <ReferenceInput
        alwaysOn
        source="company_id"
        reference="companies"
        sort={{ field: "companies.alias", order: "ASC" }}
      >
        <AutocompleteInput
          optionText="alias"
          variant="outlined"
          label="mine.label.company"
        />
      </ReferenceInput>
    );
  }
  return defaultFilter;
};
export default accountReceivableBadDebtHistoriesFilterList;
